import { format } from "date-fns";
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { formatAmount } from "library/moneyUtils";
import headerImage from "../../images/thumbnail_lsc-menu@2x.png";

const styles = StyleSheet.create({
  page: {
    fontSize: 16,
  },
  header: {
    borderBottom: "1pt solid #D6D6D6",
    padding: "24 40",
  },
  headerImage: {
    width: 164,
  },
  main: {
    padding: 40,
  },
  title: {
    fontSize: 24,
  },
  card: {
    marginTop: 32,
    padding: 16,
    backgroundColor: "#F2F2F2",
    display: "flex",
    flexDirection: "row",
  },
  cardImage: {
    width: 52,
    height: 44,
    marginRight: 16,
  },
  cardEnding: {
    marginTop: 8,
  },
  table: {
    marginTop: 32,
    padding: 16,
    border: "1pt solid #D6D6D6",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 24,
  },
  firstRow: {
    paddingTop: 0,
  },
  label: {
    width: 280,
  },
  value: {
    width: 180,
  },
});

function BpayReceiptPdf({
  cardEndsWith,
  cardName,
  biller,
  referenceNumber,
  amount,
  paymentDate,
  receiptNumber,
}) {
  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.header}>
          <Image style={styles.headerImage} src={headerImage} />
        </View>
        <View style={styles.main}>
          <Text style={styles.title}>BPay payment receipt</Text>
          <View style={styles.card}>
            <Image
              style={styles.cardImage}
              src={require("../../images/credit-card.png").default}
            />
            <View>
              <Text>{cardName}</Text>
              <Text style={styles.cardEnding}>Card ending {cardEndsWith}</Text>
            </View>
          </View>
          <View style={styles.table}>
            <View style={{ ...styles.row, ...styles.firstRow }}>
              <Text style={styles.label}>Biller name</Text>
              <Text style={styles.value}>{biller.name}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Biller code</Text>
              <Text style={styles.value}>{biller.code}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Reference number</Text>
              <Text style={styles.value}>{referenceNumber}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Amount</Text>
              <Text style={styles.value}>
                {formatAmount(amount, { withCents: true })}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Payment date</Text>
              <Text style={styles.value}>
                {format(paymentDate, "dd MMMM yyyy")}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Receipt number</Text>
              <Text style={styles.value}>{receiptNumber}</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

export { BpayReceiptPdf };
